import {useEffect, useState} from "react";
import {HideMainLoading, HideProgressLoading, ShowProgressLoading} from "../../components/template/architecture";
import {AuthRedirectSignup, PostJSON} from "../../components/api/webservice";
import {Apis} from "../../components/api/url";
import {
    CheckIcon,
    ThinCreditCardTimeIcon,
    ThinLogoutIcon,
    ThinNotAllowedIcon,
    ThinTimeIcon
} from "../../components/icons/material-icons";
import ClickOutsideDetector from "../../components/clickOutside/click-outside";
import {Link, useNavigate} from "react-router-dom";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../components/techaran/money";
import {ShowSnackbar} from "../../components/template/snackbar";
import {SignupCompleteProfile} from "./profile";

export const SignupStatusScreen = () => {
    const [data, setData] = useState({
        loaded: false,
        firstname: '',
        lastname: '',
        national: '',
        grade: 1,
        parentTell: '',
        prePaymentPrice: 0,
        approved: false,
        approvedAt: '2000-01-01 00:00:00',
        createdAt: '2000-01-01 00:00:00',
        declined: false,
        declinedAt: '2000-01-01 00:00:00',
        isPaid: false,
        traceCode: '',
        terms: '',
        isProfileComplete: false,
        isOldStudent:false,
    });
    const [termsAgreed, setTermsAgreed] = useState(false);
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/signup/status',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                a: string,
                b: string,
                c: string,
                d: number,
                e: string,
                f: number,
                g: boolean,
                h: string,
                i: string,
                j: boolean,
                k: string,
                l: boolean,
                m: string,
                n: string,
                o: boolean,
                p:boolean,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectSignup();
                    return;
                }
                setData({
                    loaded: true,
                    firstname: d.a,
                    lastname: d.b,
                    national: d.c,
                    grade: d.d,
                    parentTell: d.e,
                    prePaymentPrice: d.f,
                    approved: d.g,
                    approvedAt: d.h,
                    createdAt: d.i,
                    declined: d.j,
                    declinedAt: d.k,
                    isPaid: d.l,
                    traceCode: d.m,
                    terms: d.n,
                    isProfileComplete:d.o,
                    isOldStudent: d.p,
                });
            },
            () => {
            },
            AuthRedirectSignup,
            'signup',
        ).then(void 0);
    };
    useEffect(() => {
        document.title = 'ثبت‌نام | نهال';
        HideMainLoading();
        fetchData();
    }, []);
    const [menuOpen, setMenuOpen] = useState(false);
    const logout = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/signup/signout',
            {},
            true,
            (d: {
                result: string,
                reason: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectSignup();
                    return;
                }
                AuthRedirectSignup();
            },
            () => {
            },
            AuthRedirectSignup,
            'signup',
        ).then(void 0);
    };
    const navigate = useNavigate();
    const issueInvoice = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/signup/invoice/issue',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                nd: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectSignup();
                    return;
                }
                navigate(`/signup/invoice/${d.nd}`);
                ShowSnackbar(
                    'لطفا فاکتور صادر شده را پرداخت نمایید.',
                    'باشه',
                    5000,
                );
            },
            () => {
            },
            AuthRedirectSignup,
            'signup',
        ).then(void 0);
    };
    return (
        <>
            {
                data.loaded ?
                    <div className="container" data-aos={"fade-up"} data-aos-duration={1000}>
                        <div className="row justify-content-center">
                            <div className={data.isProfileComplete ? "col-lg-6" : 'col-lg-12'}>
                                <div className="signup-card">
                                    <div className="signup-card-header">
                                        <b>
                                            <Link to={"/"} style={{backgroundImage: 'url(/logo.png)'}}/>
                                            <span>پیش ثبت‌نام نهال</span>
                                        </b>
                                        <div className={"signup-menu" + (menuOpen ? ' active' : '')}>
                                            <button
                                                style={{backgroundImage: `url(https://techara-images.ir/u/default.png)`}}
                                                onClick={() => setMenuOpen(v => !v)}
                                            />
                                            <ClickOutsideDetector onClickOutside={() => setMenuOpen(false)}>
                                                <div>
                                                    <i style={{backgroundImage: `url(https://techara-images.ir/u/default.png)`}}/>
                                                    <span>{data.firstname + " " + data.lastname}</span>
                                                </div>
                                                <hr/>
                                                <button onClick={logout}>
                                                    <ThinLogoutIcon/>
                                                    <span>خروج از حساب</span>
                                                </button>
                                            </ClickOutsideDetector>
                                        </div>
                                    </div>
                                    {
                                        data.isProfileComplete ?
                                            <>
                                                {
                                                    data.approved && data.isPaid ?
                                                        <div className="signup-status" data-color={"green"}>
                                                            <i><CheckIcon/></i>
                                                            <b>تکمیل شده</b>
                                                            <span>مراحل ثبت‌نام شما بصورت کامل تکمیل شده است.</span>
                                                        </div> : null
                                                }
                                                {
                                                    data.approved && !data.isPaid ?
                                                        (
                                                            termsAgreed ?
                                                                <div className="signup-status" data-color={"blue"}>
                                                                    <i><ThinCreditCardTimeIcon/></i>
                                                                    <b>در انتظار پرداخت</b>
                                                                    <span>ثبت‌نام شما توسط آموزشگاه تایید شده است و پس از پرداخت پیش‌پرداخت، ثبت‌نام شما نهایی می‌شود.</span>
                                                                    <button onClick={issueInvoice}>
                                                                        پرداخت هزینه
                                                                    </button>
                                                                </div> :
                                                                <div className="signup-status" data-color={"blue"}>
                                                                    <b style={{textAlign: 'start', margin: 0}}>به شهاب خوش آمدید</b>
                                                                    <span style={{textAlign: 'justify'}}>{data.terms}</span>
                                                                    <div className="d-flex justify-content-end align-items-center">
                                                                        <button onClick={() => setTermsAgreed(true)}>
                                                                            موافقت و ادامه
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                        ) : null
                                                }
                                                {
                                                    data.declined ?
                                                        <div className="signup-status" data-color={"red"}>
                                                            <i><ThinNotAllowedIcon/></i>
                                                            <b>رد شده</b>
                                                            <span>متاسفانه، به علت تکمیل ظرفیت، درخواست ثبت‌نام شما توسط آموزشگاه رد شده است.</span>
                                                        </div> : null
                                                }
                                                {
                                                    !data.approved && !data.declined ?
                                                        <div className="signup-status" data-color={"brown"}>
                                                            <i><ThinTimeIcon/></i>
                                                            <b>در حال بررسی</b>
                                                            <span>درخواست پیش ثبت‌نام شما توسط آموزشگاه در حال بررسی (بررسی ظرفیت) می‌باشد و هرگونه تغییری در پرونده از طریق پیامک به شما اطلاع‌رسانی خواهد گردید.</span>
                                                        </div> : null
                                                }
                                            </> :
                                            <>
                                                <SignupCompleteProfile grade={data.isOldStudent ? 1 : data.grade} onDone={()=>fetchData()}/>
                                                <hr/>
                                            </>
                                    }
                                    <div className="signup-field">
                                        <b>کد رهگیری:</b>
                                        <span>{StringDigitsConvertToPersian(data.traceCode)}</span>
                                    </div>
                                    {
                                        data.approved ?
                                            <div className="signup-field">
                                                <b>پیش پرداخت:</b>
                                                <span>{CurrencyFormat(data.prePaymentPrice)} تومان</span>
                                            </div> :
                                            null
                                    }
                                    <div className="signup-field">
                                        <b>نام و نام خانوادگی:</b>
                                        <span>{data.firstname + " " + data.lastname}</span>
                                    </div>
                                    <div className="signup-field">
                                        <b>کدملی:</b>
                                        <span>{StringDigitsConvertToPersian(data.national)}</span>
                                    </div>
                                    <div className="signup-field">
                                        <b>تلفن همراه:</b>
                                        <span>{StringDigitsConvertToPersian(data.parentTell.replaceAll('+98', '0'))}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : null
            }
        </>
    );
};